import { useRef } from "react";
import { PresenceBadges } from "../../../components/presence-badges";
import { useCurrentActor } from "../../../auth/use-current-actor";
import { useCanvasViewersStore } from "../store/canvas-viewers-store";
import { useCtrlWheelZoom } from "../input/use-ctrl-wheel-zoom";

// 右上：参加ユーザー一覧。
// useCanvasViewersStore の viewers を購読してリアルタイム更新する。
// アバタークリックでフォーカスモードを切り替えられる。
export function PresenceList(): JSX.Element {
  const viewers = useCanvasViewersStore((s) => s.viewers);
  const focusedUserId = useCanvasViewersStore((s) => s.focusedUserId);
  const setFocusedUserId = useCanvasViewersStore((s) => s.setFocusedUserId);
  const currentActor = useCurrentActor();
  // 自分自身のアバターをクリックしてもフォーカスは無意味なので、フォーカス対象から除外する。
  // PresenceBadges 側へは onFocusViewer 自体を渡さず、装飾用の表示のみとする。
  const list = Object.values(viewers);
  // このパネル上での Ctrl+ホイールもキャンバスズームに振り替える（ブラウザ拡大を防ぐ）。
  const rootRef = useRef<HTMLDivElement | null>(null);
  useCtrlWheelZoom(rootRef);

  // アバタークリック: フォーカス未開始ならフォーカス開始、既にフォーカス中の同一ユーザーなら解除。
  // 自分自身（currentActor.userId と一致するユーザー）はフォーカス対象外として、クリックを無視する。
  const onFocusViewer = (userId: string): void => {
    if (userId === currentActor.userId) return;
    setFocusedUserId(focusedUserId === userId ? null : userId);
  };

  return (
    <div ref={rootRef} data-focus-control>
      <PresenceBadges
        viewers={list}
        onFocusViewer={onFocusViewer}
        focusedUserId={focusedUserId}
        currentUserId={currentActor.userId}
      />
    </div>
  );
}
